import { render, staticRenderFns } from "./AchievementCard.vue?vue&type=template&id=299d2c54"
import script from "./AchievementCard.vue?vue&type=script&lang=js"
export * from "./AchievementCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports